/**
 * "<game> · from Slot Check Search" subtitle in the Explore drawer (mock 06).
 * Explore sets it when it applies a Slot Check Search filter; the drawer shows
 * it only while that same filter is still the one in view (search mode on and
 * the chip name unchanged), so any other search / filter / casino hides it.
 */
type Label = { casinoId: number; filterName: string } | null;

let current: Label = null;
const listeners = new Set<() => void>();

export function setUniversalSearchExploreLabel(label: Label): void {
  current = label;
  listeners.forEach((l) => l());
}

export function getUniversalSearchExploreLabel(): Label {
  return current;
}

export function subscribeUniversalSearchExploreLabel(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Subtitle text, or '' when the filter in view is not the one Slot Check Search applied. */
export function universalSearchExploreSubtitle(
  label: Label,
  view: { casinoId: unknown; isSearchMode: boolean; selectedSlotsName: string | null | undefined }
): string {
  if (!label || !view.isSearchMode) return '';
  if (Number(view.casinoId) !== label.casinoId) return '';
  if ((view.selectedSlotsName || '').trim() !== label.filterName.trim()) return '';
  return `${label.filterName} · from Slot Check Search`;
}
